var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0943 6.32937C22.1978 6.24143 22.3533 6.25393 22.4414 6.35725C22.5294 6.46067 22.5169 6.6162 22.4135 6.70433L14.0952 13.7997C14.0055 13.8762 13.8739 13.878 13.7818 13.8045L10.7061 11.3442L1.93881 18.1771C1.83159 18.2605 1.67715 18.241 1.59365 18.1339C1.51034 18.0267 1.52979 17.8722 1.63692 17.7887L10.5571 10.8366C10.647 10.7665 10.7739 10.7673 10.8628 10.8385L13.9298 13.2921L22.0943 6.32937Z",
    fill: "#011E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7787 11.0221L1.89275 17.7507V21.1326C1.89275 21.6763 2.33353 22.1171 2.87726 22.1171H22.4872V6.65743L13.9351 13.6123L10.7787 11.0221Z",
    fill: "#0054EC",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 21.1958V3.47464C1.5 3.33871 1.60892 3.22852 1.74327 3.22852C1.87763 3.22852 1.98655 3.33871 1.98655 3.47464V21.1958C1.98655 21.6036 2.3133 21.9342 2.71637 21.9342H22.2439C22.3783 21.9342 22.4872 22.0444 22.4872 22.1803C22.4872 22.3163 22.3783 22.4265 22.2439 22.4265H2.71637C2.04459 22.4265 1.5 21.8755 1.5 21.1958Z",
    fill: "#596773"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line_chart.975434c1daacf76a6d3bab76f4d09a63.svg";
export { ForwardRef as ReactComponent };